import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 版本
    gameVersion: 3,
  },
  getters: {},
  mutations: {
    // 设置版本
    setGameVersion(state, version) {
      state.gameVersion = version;
    },
  },
  actions: {},
  modules: {},
});
